import { render, staticRenderFns } from "./orderDatagramDetail.vue?vue&type=template&id=61708448&scoped=true"
import script from "./orderDatagramDetail.vue?vue&type=script&lang=js"
export * from "./orderDatagramDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDatagramDetail.vue?vue&type=style&index=0&id=61708448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61708448",
  null
  
)

export default component.exports